import project1_1 from "../assets/project1/project1_1.svg";
import project1_2 from "../assets/project1/project1_2.svg";
import project1_3 from "../assets/project1/project1_3.svg";
import project1_4 from "../assets/project1/project1_4.svg";
import project1_5 from "../assets/project1/project1_5.svg";
import project1_6 from "../assets/project1/project1_6.svg";
import project1_7 from "../assets/project1/project1_7.svg";
import project1_8 from "../assets/project1/project1_8.svg";
import project1_9 from "../assets/project1/project1_9.svg";
import project2_1 from "../assets/project2/project2_1.svg";
import project2_2 from "../assets/project2/project2_2.svg";
import project2_3 from "../assets/project2/project2_3.svg";
import project2_4 from "../assets/project2/project2_4.svg";
import project2_5 from "../assets/project2/project2_5.svg";
import project2_6 from "../assets/project2/project2_6.svg";
import project2_7 from "../assets/project2/project2_7.svg";
import project2_8 from "../assets/project2/project2_8.svg";
import project2_9 from "../assets/project2/project2_9.svg";
import project3_1 from "../assets/project3/project3_1.svg";
import project3_2 from "../assets/project3/project3_2.svg";
import project3_3 from "../assets/project3/project3_3.svg";
import project3_4 from "../assets/project3/project3_4.svg";
import project3_5 from "../assets/project3/project3_5.svg";
import project3_6 from "../assets/project3/project3_6.svg";
import project4_1 from "../assets/project4/project4_1.svg";
import project4_2 from "../assets/project4/project4_2.svg";
import project4_3 from "../assets/project4/project4_3.svg";
import project4_4 from "../assets/project4/project4_4.svg";
import project4_5 from "../assets/project4/project4_5.svg";
import project4_6 from "../assets/project4/project4_6.svg";
import project4_7 from "../assets/project4/project4_7.svg";
import project4_8 from "../assets/project4/project4_8.svg";
import project5_1 from "../assets/project5/project5_1.svg";
import project5_2 from "../assets/project5/project5_2.svg";
import project5_3 from "../assets/project5/project5_3.svg";
import project5_4 from "../assets/project5/project5_4.svg";
import project5_5 from "../assets/project5/project5_5.svg";
import project5_6 from "../assets/project5/project5_6.svg";
import project6_1 from "../assets/project6/project6_1.svg";
import project6_2 from "../assets/project6/project6_2.svg";
import project6_3 from "../assets/project6/project6_3.svg";
import project6_4 from "../assets/project6/project6_4.jpg";
import project6_5 from "../assets/project6/project6_5.svg";
import project6_6 from "../assets/project6/project6_6.svg";

export const listOfImages = {
  project1: [
    project1_1,
    project1_2,
    project1_3,
    project1_4,
    project1_5,
    project1_6,
    project1_7,
    project1_8,
    project1_9,
  ],
  project2: [
    project2_1,
    project2_2,
    project2_3,
    project2_4,
    project2_5,
    project2_6,
    project2_7,
    project2_8,
    project2_9,
  ],
  project3: [
    project3_1,
    project3_2,
    project3_3,
    project3_4,
    project3_5,
    project3_6,
  ],
  project4: [
    project4_1,
    project4_2,
    project4_3,
    project4_4,
    project4_5,
    project4_6,
    project4_7,
    project4_8,
  ],
  project5: [
    project5_1,
    project5_2,
    project5_3,
    project5_4,
    project5_5,
    project5_6,
  ],
  project6: [
    project6_1,
    project6_2,
    project6_3,
    project6_5,
    project6_4,
    project6_6,
  ],
};

export default listOfImages;
